<ng-container *ngIf="isStep('insertion-list')">
  <rt-redactor-inserts-dropdown-item
    [iconName]="'gdpr-candidate'"
    [heading]="'app.redactor_inserts.gdpr.dropdown.heading' | translate"
    [subheading]="'app.redactor_inserts.gdpr.dropdown.subheading' | translate"
    [link]="'settings/company/gdpr'"
    [selected]="selected"
    (stepInside)="goSecondStep()"
  >
  </rt-redactor-inserts-dropdown-item>
</ng-container>

<ng-container *ngIf="isStep('gdpr-links') || isStep('gdpr-links-without-consent')">
  <div #container (keydown)="handleKeyDown($event)" tabindex="0" class="wrapper">
    <rt-redactor-inserts-dropdown-header
      [hasBackAction]="hasBackAction"
      [hasSettings]="true"
      [label]="'app.redactor_inserts.gdpr.dropdown.heading' | translate"
      (goBack)="goBack()"
      (goToSettings)="goToSettings('/settings/company/gdpr')"
      (closeDropdown)="closeDropdown.emit()"
    >
    </rt-redactor-inserts-dropdown-header>

    <rt-dropdown-item [highlighted]="state.selectedIndex === 0" (click)="openModal('removal')">
      <rt-icon prefix name="remove-circle"></rt-icon>
      <rt-heading variant="heading">
        {{ 'app.redactor_inserts.gdpr.dropdown.removal_heading' | translate }}
      </rt-heading>
      <div class="info-dropdown-text">
        {{ 'app.redactor_inserts.gdpr.dropdown.removal_subheading' | translate }}
      </div>
    </rt-dropdown-item>
    <rt-dropdown-item [highlighted]="state.selectedIndex === 1" (click)="openModal('change')">
      <rt-icon prefix name="edit"></rt-icon>
      <rt-heading variant="heading">
        {{ 'app.redactor_inserts.gdpr.dropdown.change_heading' | translate }}
      </rt-heading>
      <div class="info-dropdown-text">
        {{ 'app.redactor_inserts.gdpr.dropdown.change_subheading' | translate }}
      </div>
    </rt-dropdown-item>
    <rt-dropdown-item
      *ngIf="isConsentRequestShow"
      [highlighted]="state.selectedIndex === 2"
      [noDivider]="true"
      (click)="openConsentRequestModal()"
    >
      <rt-icon prefix name="account-check"></rt-icon>
      <rt-heading variant="heading">
        {{ 'app.redactor_inserts.gdpr.dropdown.consent_request_heading' | translate }}
      </rt-heading>
      <div class="info-dropdown-text">
        {{ 'app.redactor_inserts.gdpr.dropdown.consent_request_subheading' | translate }}
      </div>
    </rt-dropdown-item>
  </div>
</ng-container>
